import type { FinanceStatus, PaymentMethod, Recurrence } from '@/types/database';

export function formatBRL(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
}

export function formatBRLShort(value: number): string {
  const v = value || 0;
  if (Math.abs(v) >= 1_000_000) return `R$ ${(v / 1_000_000).toFixed(1)}M`;
  if (Math.abs(v) >= 1_000) return `R$ ${(v / 1_000).toFixed(1)}K`;
  return formatBRL(v);
}

export const STATUS_LABELS: Record<FinanceStatus, string> = {
  pending: 'Pendente',
  paid: 'Pago',
  overdue: 'Vencido',
  canceled: 'Cancelado',
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: 'Dinheiro',
  pix: 'PIX',
  card_credit: 'Cartão de crédito',
  card_debit: 'Cartão de débito',
  boleto: 'Boleto',
  transfer: 'Transferência',
  other: 'Outro',
};

export const RECURRENCE_LABELS: Record<Recurrence, string> = {
  none: 'Não repetir',
  weekly: 'Semanal',
  monthly: 'Mensal',
  yearly: 'Anual',
};

/** Human-friendly due-date proximity label for a pending/overdue entry. */
export function dueBadge(dueDate: string, today: string): { label: string; tone: 'overdue' | 'today' | 'soon' | 'future' } {
  if (dueDate < today) return { label: 'Vencido', tone: 'overdue' };
  if (dueDate === today) return { label: 'Hoje', tone: 'today' };
  const diffDays = Math.round((new Date(dueDate).getTime() - new Date(today).getTime()) / 86_400_000);
  if (diffDays <= 3) return { label: `Em ${diffDays} dia${diffDays > 1 ? 's' : ''}`, tone: 'soon' };
  return { label: `Em ${diffDays} dias`, tone: 'future' };
}
